import { render, staticRenderFns } from "./ProfessorVinculoCard.vue?vue&type=template&id=036b911c&scoped=true"
import script from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
export * from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorVinculoCard.vue?vue&type=style&index=0&id=036b911c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b911c",
  null
  
)

export default component.exports